import React from 'react';

const CoApplicantForm = ({ index, data, err, onChange, onFileChange, minBirthDate, maxBirthDate }) => {
    const {
        salutation, forename, lastname, address, zip, city, phone, email,
        dateOfBirth, occupation, monthlyIncome, gwgTenant, debtInformation,
        debtUploading, debtUploadError,
        employer, landlord,
    } = data;
    const e = err || {};

    return (
        <div className="mb-5 pb-5 border-bottom">
            <h3>Person {index + 2}</h3>

            <fieldset className="mb-3">
                <legend className="form-label">Anrede</legend>
                <div className="d-flex flex-column flex-md-row gap-2 gap-md-3">
                    {[['ms', 'Frau'], ['mr', 'Herr'], ['neutral', 'Neutrale Anrede']].map(([val, label]) => (
                        <div className="form-check" key={val}>
                            <input className="form-check-input" type="radio" id={`sal_${index}_${val}`} name={`salutation_${index}`} value={val} checked={salutation === val} onChange={onChange('salutation')} />
                            <label className="form-check-label" htmlFor={`sal_${index}_${val}`}>{label}</label>
                        </div>
                    ))}
                </div>
            </fieldset>

            <div className="row mb-3">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor={`co_forename_${index}`}>Vorname <span className="required-marker">*</span></label>
                    <input id={`co_forename_${index}`} name={`coApplicants[${index}][forename]`} type="text" className={`form-control${e.forename ? ' is-invalid' : ''}`} value={forename} onChange={onChange('forename')} />
                    {e.forename && <div className="invalid-feedback">{e.forename}</div>}
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor={`co_lastname_${index}`}>Nachname <span className="required-marker">*</span></label>
                    <input id={`co_lastname_${index}`} name={`coApplicants[${index}][lastname]`} type="text" className={`form-control${e.lastname ? ' is-invalid' : ''}`} value={lastname} onChange={onChange('lastname')} />
                    {e.lastname && <div className="invalid-feedback">{e.lastname}</div>}
                </div>
            </div>

            <div className="mb-3">
                <label className="form-label" htmlFor={`co_address_${index}`}>Strasse und Hausnummer <span className="required-marker">*</span></label>
                <input id={`co_address_${index}`} name={`coApplicants[${index}][address]`} type="text" className={`form-control${e.address ? ' is-invalid' : ''}`} value={address} onChange={onChange('address')} />
                {e.address && <div className="invalid-feedback">{e.address}</div>}
            </div>

            <div className="row mb-3">
                <div className="col-12 col-md-4">
                    <label className="form-label" htmlFor={`co_zip_${index}`}>PLZ <span className="required-marker">*</span></label>
                    <input id={`co_zip_${index}`} name={`coApplicants[${index}][zip]`} inputMode="numeric" type="text" className={`form-control${e.zip ? ' is-invalid' : ''}`} value={zip} onChange={onChange('zip')} />
                    {e.zip && <div className="invalid-feedback">{e.zip}</div>}
                </div>
                <div className="col-12 col-md-8">
                    <label className="form-label" htmlFor={`co_city_${index}`}>Ort</label>
                    <input id={`co_city_${index}`} name={`coApplicants[${index}][city]`} type="text" className="form-control" value={city} onChange={onChange('city')} />
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor={`co_phone_${index}`}>Telefon <span className="required-marker">*</span></label>
                    <input id={`co_phone_${index}`} name={`coApplicants[${index}][phone]`} type="tel" className={`form-control${e.phone ? ' is-invalid' : ''}`} value={phone} onChange={onChange('phone')} />
                    {e.phone && <div className="invalid-feedback">{e.phone}</div>}
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor={`co_email_${index}`}>E-Mail</label>
                    <input id={`co_email_${index}`} name={`coApplicants[${index}][email]`} type="email" className={`form-control${e.email ? ' is-invalid' : ''}`} value={email} onChange={onChange('email')} />
                    {e.email && <div className="invalid-feedback">{e.email}</div>}
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor={`co_dateOfBirth_${index}`}>Geburtsdatum <span className="required-marker">*</span></label>
                    <input id={`co_dateOfBirth_${index}`} name={`coApplicants[${index}][dateOfBirth]`} type="date" className={`form-control${e.dateOfBirth ? ' is-invalid' : ''}`} value={dateOfBirth} min={minBirthDate} max={maxBirthDate} onChange={onChange('dateOfBirth')} />
                    {e.dateOfBirth && <div className="invalid-feedback">{e.dateOfBirth}</div>}
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor={`co_occupation_${index}`}>Beruf</label>
                    <input id={`co_occupation_${index}`} name={`coApplicants[${index}][occupation]`} type="text" className="form-control" value={occupation} onChange={onChange('occupation')} />
                </div>
            </div>

            <div className="row mb-4">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor={`co_monthlyIncome_${index}`}>Monatliches Bruttoeinkommen <span className="required-marker">*</span></label>
                    <div className="input-group">
                        <span className="input-group-text">CHF</span>
                        <input id={`co_monthlyIncome_${index}`} name={`coApplicants[${index}][monthlyIncome]`} type="number" className={`form-control${e.monthlyIncome ? ' is-invalid' : ''}`} min={0} value={monthlyIncome} onChange={onChange('monthlyIncome')} />
                        {e.monthlyIncome && <div className="invalid-feedback">{e.monthlyIncome}</div>}
                    </div>
                </div>
            </div>

            <fieldset className="mb-4">
                <legend className="form-label">Wohnt aktuell bei der GWG? <span className="required-marker">*</span></legend>
                <div className="form-check">
                    <input className={`form-check-input${e.gwgTenant ? ' is-invalid' : ''}`} type="radio" id={`gwg_yes_${index}`} name={`gwgTenant_${index}`} value="yes" checked={gwgTenant === 'yes'} onChange={onChange('gwgTenant')} />
                    <label className="form-check-label" htmlFor={`gwg_yes_${index}`}>Ja</label>
                </div>
                <div className="form-check">
                    <input className={`form-check-input${e.gwgTenant ? ' is-invalid' : ''}`} type="radio" id={`gwg_no_${index}`} name={`gwgTenant_${index}`} value="no" checked={gwgTenant === 'no'} onChange={onChange('gwgTenant')} />
                    <label className="form-check-label" htmlFor={`gwg_no_${index}`}>Nein</label>
                </div>
                {e.gwgTenant && <div className="invalid-feedback d-block">{e.gwgTenant}</div>}
            </fieldset>

            {gwgTenant === 'no' && (
                <div className="mb-4">
                    <label className="form-label" htmlFor={`co_debtInformation_${index}`}>Betreibungsauskunft (nicht älter als 3 Monate) <span className="required-marker">*</span></label>
                    <input
                        id={`co_debtInformation_${index}`}
                        name={`coApplicants[${index}][debtInformation]`}
                        type="file"
                        className={`form-control${e.debtInformation ? ' is-invalid' : ''}`}
                        accept=".pdf,.jpg,.jpeg,.png,.bmp"
                        disabled={debtUploading}
                        onChange={(ev) => onFileChange(ev.target.files[0] || null)}
                    />
                    {debtUploading && (
                        <small className="text-muted mt-1 d-block">
                            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                            Wird hochgeladen…
                        </small>
                    )}
                    {!debtUploading && debtInformation && <small className="text-muted text-break mt-1 d-block">{debtInformation.name}</small>}
                    {debtUploadError && <div className="invalid-feedback d-block">{debtUploadError}</div>}
                    {e.debtInformation && <div className="invalid-feedback d-block">{e.debtInformation}</div>}
                </div>
            )}

            <h4 className="mt-4">Referenz/Kontakt Arbeitgeber:in</h4>
            <div className="row mb-3">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor={`co_employerCompany_${index}`}>Firma</label>
                    <input id={`co_employerCompany_${index}`} name={`coApplicants[${index}][employerCompany]`} autoComplete="organization" type="text" className="form-control" value={employer?.company || ''} onChange={onChange('employerCompany')} />
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor={`co_employerPerson_${index}`}>Referenzperson</label>
                    <input id={`co_employerPerson_${index}`} name={`coApplicants[${index}][employerPerson]`} autoComplete="off" type="text" className="form-control" value={employer?.person || ''} onChange={onChange('employerPerson')} />
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor={`co_employerPhone_${index}`}>Telefon</label>
                    <input id={`co_employerPhone_${index}`} name={`coApplicants[${index}][employerPhone]`} autoComplete="off" type="tel" className="form-control" value={employer?.phone || ''} onChange={onChange('employerPhone')} />
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor={`co_employerOccupation_${index}`}>Beruf</label>
                    <input id={`co_employerOccupation_${index}`} name={`coApplicants[${index}][employerOccupation]`} autoComplete="off" type="text" className="form-control" value={employer?.occupation || ''} onChange={onChange('employerOccupation')} />
                </div>
            </div>

            <h4 className="mt-4">Referenz/Kontakt jetzige:r Vermieter:in</h4>
            <div className="row mb-3">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor={`co_landlordName_${index}`}>Firma/Name</label>
                    <input id={`co_landlordName_${index}`} name={`coApplicants[${index}][landlordName]`} autoComplete="off" type="text" className="form-control" value={landlord?.name || ''} onChange={onChange('landlordName')} />
                </div>
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor={`co_landlordPhone_${index}`}>Telefon</label>
                    <input id={`co_landlordPhone_${index}`} name={`coApplicants[${index}][landlordPhone]`} autoComplete="off" type="tel" className="form-control" value={landlord?.phone || ''} onChange={onChange('landlordPhone')} />
                </div>
            </div>
        </div>
    );
};

const AppCoApplicants = ({ err, values, handleCoApplicantChange, handleCoApplicantFile, prevStep, nextStep, focusedTitleRef, anyUploading, minBirthDate, maxBirthDate }) => {
    const { coApplicants } = values;
    const coErr = (err || {}).coApplicants || [];

    return (
        <div>
            <h2 ref={focusedTitleRef} tabIndex={-1}>Mitbewerber:innen</h2>

            {coApplicants.map((ca, i) => (
                <CoApplicantForm
                    key={i}
                    index={i}
                    data={ca}
                    err={coErr[i]}
                    onChange={handleCoApplicantChange(i)}
                    onFileChange={handleCoApplicantFile(i)}
                    minBirthDate={minBirthDate}
                    maxBirthDate={maxBirthDate}
                />
            ))}

            <div className="d-flex justify-content-between flex-row-reverse mt-5">
                <button className="btn btn-secondary" onClick={nextStep} disabled={anyUploading}>Weiter</button>
                <button className="btn btn-secondary btn-back" onClick={prevStep}>Zurück</button>
            </div>
        </div>
    );
};

export default AppCoApplicants;
